import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { A } from '../../common';

function Tab({ tab, handleTab }) {
  const { t } = useTranslation();
  return (
    <div className="header">
      <div className="header_tab2 btn_type">
        <ul className="tablist cls">
          <li>
            <A
              className={clsx({ 'active': tab.indexOf("course") > -1})}
              onClick={() => handleTab("course_tab1")}
            >
              {t("LC_01_02.msg003")}
            </A>
          </li>
          <li>
            <A
              className={clsx({ 'active': tab.indexOf("theme") > -1 })}
              onClick={() => handleTab("theme")}
            >
              {t("LC_01_02.msg005")}
            </A>
          </li>
          <li>
            <A
              className={clsx({ 'active': tab.indexOf("ocr") > -1 })}
              onClick={() => handleTab("ocr")}
            >
              {t("LC_01_02.msg009")}
            </A>
          </li>
        </ul>
      </div>
      {
        tab.indexOf("course") > -1 && (
          <div className="header_tab2 blue_line_type">
            <ul className="cls">
              <li>
                <A 
                  className={clsx({'active': tab === 'course_tab1'})}
                  onClick={() => handleTab("course_tab1")}
                >
                  {t("LC_03_05_01.msg002")}
                </A>
              </li>
              <li>
                <A
                  className={clsx({ 'active': tab === 'course_tab2' })}
                  onClick={() => handleTab("course_tab2")}
                >
                  {t("LC_03_05_01.msg003")}
                </A>
              </li>
              <li>
                <A
                  className={clsx({ 'active': tab === 'course_tab3' })}
                  onClick={() => handleTab("course_tab3")}
                >
                  {t("LC_03_05_01.msg004")}
                </A>
              </li>
            </ul>
          </div>
        )
      }
    </div>
  );
}

export default Tab;